module.exports = __webpack_public_path__ + "static/media/img6.95789e38.PNG";